import { render, staticRenderFns } from "./lrSelectBox.vue?vue&type=template&id=4652f8e9&"
import script from "./lrSelectBox.vue?vue&type=script&lang=js&"
export * from "./lrSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./lrSelectBox.vue?vue&type=style&index=0&id=4652f8e9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports